export enum TasksSettingsScreen {
  List,
  Edit,
  Remove
}
